<ng-container *ngIf="appearance=='legacy'">

    <button class="trigger-btn" (click)="toggleTrigger($event)" type="button" #btnRef cdkOverlayOrigin #trigger="cdkOverlayOrigin">
        <div #btnLabelRef class="btn-row">
            <div class="label">{{ translateHelper.localize(customLabel||label) }}
                <ng-container *ngIf="minControl?.value || maxControl?.value">
                    <span *ngIf="minControl?.value && !maxControl?.value">: {{'from' | translate}} {{minControl.value}}</span>
                    <span *ngIf="!minControl?.value && maxControl?.value">: {{'to' | translate}} {{maxControl.value}}</span>
                    <span *ngIf="minControl?.value && maxControl?.value">: {{'from' | translate}} {{minControl.value}} - {{'to' | translate}} {{maxControl.value}}</span>
                </ng-container>

            </div>
            <mat-icon #btnIconRef>expand_more</mat-icon>
        </div>
    </button>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isOpen" (overlayOutsideClick)="menuClickOutside($event)">
        <div class="bubble">
            <div class="inner-container">
                <ng-container>
                    <div class="flex flex-row gap-1 range-container">
                        <div class="">
                            <input matInput [formControl]="minControl" [placeholder]="'min' | translate" type="number" autocomplete="off" />
                        </div>
                        <span class="pt-1">-</span>
                        <div class="">
                            <input matInput autocomplete="off" [formControl]="maxControl" [placeholder]="'max' | translate" type="number" />
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </ng-template>

</ng-container>
<ng-container *ngIf="appearance=='filter'">

    <div class="widget-filters__list">
        <div class="widget-filters__item">
            <div class="filter filter--opened" appCollapseItem="filter--opened" #collapse="appCollapseItem">

                <button type="button" class="filter__title" (click)="collapse.toggle()">
                    <span class="me-2">•</span> {{ translateHelper.localize(customLabel||label) }}
                    <img src="assets/svg/filters/collapse_arrow.svg" class="collapse-arrow">
                </button>
                <div class="filter__body" appCollapseContent>
                    <div class="filter__container">

                        <div class="filter-list">
                            <div class="filter-list__list">
                                <div class="inner-container">
                                    <div class="flex flex-row gap-1 range-container">
                                        <div class="">
                                            <input matInput [formControl]="minControl" [placeholder]="'min' | translate" type="number" autocomplete="off" />
                                        </div>
                                        <span class="pt-1">-</span>
                                        <div class="">
                                            <input matInput autocomplete="off" [formControl]="maxControl" [placeholder]="'max' | translate" type="number" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>